export default __webpack_public_path__ + "static/screenshot_3-eeccbaff25e5aa628111d5975a774a5c.png";